import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DatePickerISO } from '../DatePickerISO';
import { FiasOverrider } from '../FiasOverrider';
import { FieldWrapper } from '../FieldWrapper';
import { TextFieldWrapper } from '../TextFieldWrapper';
export const RegistrationAddress = ({ value, onValueChange, validationInfo, residenceDateValidationInfo, showDateInput = false, }) => {
    const handleAddressChange = (newAddress) => {
        onValueChange({
            ...newAddress,
            residenceDate: value.residenceDate,
        });
    };
    const handleResidenceDateChange = (newDate) => {
        onValueChange({
            ...value,
            residenceDate: newDate.trim() || undefined,
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(TextFieldWrapper, { label: "\u0410\u0434\u0440\u0435\u0441 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438", children: [value?.text && _jsx("div", { "data-tid": "registrationAddressInput", children: value.text }), _jsx(FiasOverrider, { value: value, onValueChange: handleAddressChange, validationInfo: validationInfo })] }), showDateInput && (_jsx(FieldWrapper, { label: "\u0414\u0430\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438", children: _jsx(DatePickerISO, { value: value.residenceDate || '', onValueChange: handleResidenceDateChange, validationInfo: residenceDateValidationInfo }) }))] }));
};
